import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ResPillComponent } from '../../../components/res-pill/res-pill.component';
import { ReportTraceabilityRow } from '../../../models/release-report.model';
import {
  PlanCaseResult,
  planCaseResult,
} from '../plan-ergebnis-tabelle/plan-faelle-tabelle/plan-faelle-tabelle.component';

@Component({
  selector: 'app-report-doc-trace',
  imports: [TranslatePipe, ResPillComponent],
  templateUrl: './report-doc-trace.component.html',
  styleUrl: './report-doc-trace.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportDocTraceComponent {
  readonly rows = input.required<ReportTraceabilityRow[]>();

  protected resultOf(row: ReportTraceabilityRow): PlanCaseResult | null {
    return row.status ? planCaseResult(row.status) : null;
  }
}
